import React, { useState } from "react";
import { Typography, Grid, Button, Box, Container } from "@mui/material";

const PresentationResults = (props) => {

    const ACCUMULATION_CHART = 0;
    const DISTRIBUTION_CHART = 1;
    const VOLATILITY_BUFFER_CHART = 2;

    const [activeLink, setActiveLink] = useState({
        [ACCUMULATION_CHART]: true,
        [DISTRIBUTION_CHART]: false,
        [VOLATILITY_BUFFER_CHART]: false
    })

    const handleActiveLink = (idx) => {

        setActiveLink({
            [ACCUMULATION_CHART]: false,
            [DISTRIBUTION_CHART]: false,
            [VOLATILITY_BUFFER_CHART]: false,
            [idx]: true
        })

        props.setPresentationPage(idx);


    }

    const FancyButton = (props) => {
        const { text, shadow = true, onClick, activeLink } = props;

        return (
            <div style={{ display: 'flex', alignItems: 'center' }}
                className={`container ${shadow ? 'shadow' : ''}`}
            >
                <div
                    onClick={onClick}
                    style={{ marginLeft: '3em', padding: '6px', width: '100%', cursor: 'pointer' }}
                >
                    <a className={"button"} style={{ color: `${props.activeLink ? 'white' : '#C9C9C9'}`, fontSize: '20px', fontWeight: 'bold', alignSelf: 'center' }} > 
                    {text} 
                    </a>
                </div>
            </div>)
    }

    return (
        <Grid>
            <Grid container >
                <Grid item xs={12} className={"top-gradient-bar bar-with-text"} >
                    <Box color={'white'} style={{ color: "white", marginLeft: '4%', fontSize: '28px', display: 'flex', flexDirection: 'row' }}>
                        <FancyButton
                            activeLink={activeLink[ACCUMULATION_CHART]}
                            onClick={() => handleActiveLink(ACCUMULATION_CHART)}
                            text={"Accumulation Chart"} shadow={false} />

                        <FancyButton
                            activeLink={activeLink[DISTRIBUTION_CHART]}
                            onClick={() => handleActiveLink(DISTRIBUTION_CHART)}
                            text={"Distribution Chart"} />

                        <FancyButton
                            activeLink={activeLink[VOLATILITY_BUFFER_CHART]}
                            onClick={() => handleActiveLink(VOLATILITY_BUFFER_CHART)}
                            text={"Volatility Buffer Chart"} />
                    </Box>

                </Grid>
                {props.children[0]}
            </Grid>
            {props.children[1]}
        </Grid>
    );
};

export default PresentationResults;